
const installationTableFields = vm => [
  {
    key: 'installationName',
    sortable: false,
    label: vm.$t('installation-manager.query.list.column-titles.installation'),
    class: 'installation-list__cell-installation',
  },
  {
    key: 'state',
    sortable: false,
    label: vm.$t('installation-manager.query.list.column-titles.federative-unit'),
    class: 'truncate installation-list__cell-federative-unit',
  },
  {
    key: 'complex',
    sortable: false,
    label: vm.$t('installation-manager.query.list.column-titles.complex'),
    class: 'installation-list__cell-complex',
  },
  {
    key: 'installationType',
    sortable: false,
    label: vm.$t('installation-manager.query.list.column-titles.installation-type'),
    class: 'installation-list__cell-installation-type',
  },
  {
    key: 'regionalName',
    sortable: false,
    label: vm.$t('installation-manager.query.list.column-titles.regional'),
    class: 'installation-list__cell-regional',
  },
  {
    key: 'companyName',
    sortable: false,
    label: vm.$t('installation-manager.query.list.column-titles.company'),
    class: 'installation-list__cell-company',
  },
  {
    key: 'actions',
    sortable: false,
    label: '',
    class: 'installation-list__cell-actions',
  },
];

export default installationTableFields;
